<template>
  <div v-loading="loading">
      <pt-page-title :title="`${isEdit ? '编辑' :'新建'}海报`">
      </pt-page-title>
    <pt-poster-form ref="form" class="pt-poster-form__withData" v-model="currentForm"></pt-poster-form>
    <div class="button-div">
          <el-button type="primary" @click="save">保存</el-button>
          <el-button type="primary" plain @click="cancel">取消</el-button>
      </div>
  </div>
</template>

<script>
import PtPosterForm from './index'
export default {
  name: 'pt-poster-form__withData',
  components: {
    'pt-poster-form': PtPosterForm
  },
  computed: {
    form () {
      return this.$refs.form
    },
    isEdit () {
      return this.$route.params.isEdit !== 'false'
    }
  },
  data () {
    return {
      loading: false,
      currentForm: {}
    }
  },
  methods: {
    save () {
      this.$refs.form.validate().then(formValue => {
        this.loading = true
        console.log('currentForm======', this.currentForm)
        // this.changeForm()
        this.isEdit ? this.edit() : this.create()
      })
    },
    create () {
      console.log('this.changeForm()-------', this.currentForm)
      this.$store.dispatch('createPoster', this.currentForm).then(data => {
        this.loading = false
        this.$message.success('创建成功！')
        this.cancel()
      }).catch(errorMessage => {
        console.error(errorMessage)
        this.loading = false
        this.$message.error(errorMessage)
      })
    },
    edit () {
      console.log('this.changeForm()-------', this.currentForm)
      this.$store.dispatch('updatePoster', this.currentForm).then(data => {
        this.loading = false
        this.$message.success('保存成功！')
        this.cancel()
      }).catch(errorMessage => {
        console.error(errorMessage)
        this.loading = false
        this.$message.error(errorMessage)
      })
    },
    cancel () {
      history.go(-1)
    },
    load () {
      this.loading = true
      this.$store.dispatch('getPosterDetail', this.$route.params.id).then(data => {
        if (data.rightText) {
          data.rightText = data.rightText.replace(/<br>/g, '\n')
        }
        this.currentForm = data
        this.loading = false
        data.goodsId && this.getGoodsDetail(data.goodsId)
        console.log('====currentForm', this.currentForm)
      }).catch(errorMessage => {
        console.error(errorMessage)
        this.loading = false
        this.$message.error(errorMessage)
      })
    },
    //  获取商品详情
    getGoodsDetail (id) {
      this.loading = true
      this.$store.dispatch('getCommodityDetailPoster', id).then(res => {
        this.loading = false
        this.$set(this.currentForm, 'goodsData', res)
      }).catch(err => {
        this.loading = true
        this.$message.error(err || '获取商品详情失败', 'error')
      })
    }
  },
  created () {
    if (this.isEdit) {
      this.load()
    }
  }
}
</script>
